module.exports = __webpack_public_path__ + "static/media/london_3.748d33e3.png";